import {FaGithub, FaInstagram, FaLinkedin, FaSoundcloud} from "react-icons/fa";
import {FaXTwitter} from "react-icons/fa6";
import {GoArrowUpRight} from "react-icons/go";
import aerecuraxLogo from '../resources/aerecurax.svg';
import Layout from './Layout';
import useDocumentTitle from '../hooks/useDocumentTitle';

const projects = [
    {
        name: 'Ace',
        url: 'https://getace.app',
        description: 'Desktop app with the file sharing experience you need',
    },
    {
        name: 'Contemplate',
        url: 'https://github.com/contemplr/contemplate',
        description: 'CLI tool for templating reusable project structures',
    },
];

function Main() {
    useDocumentTitle('About');
    return (
        <Layout>
            <div className="about">
                <img src={aerecuraxLogo} alt="Aerecurax Logo" className="about-logo"/>

                <span className={"about-name"}>aerecurax - “The Skybound Executioner”</span>

                <div className="about-projects">
                    <h3 className="about-projects-heading">Projects</h3>
                    {projects.map(({name, url, description}) => (
                        <a
                            key={name}
                            href={url}
                            target="_blank"
                            rel="noreferrer"
                            className="about-project"
                        >
                            <span className="about-project-name">
                                {name} <GoArrowUpRight className="about-project-arrow"/>
                            </span>
                            <span className="about-project-desc">{description}</span>
                        </a>
                    ))}
                </div>
                <div className="about-socials">
                    <a href="https://www.linkedin.com/in/aerecurax" target="_blank" rel="noreferrer">
                        <FaLinkedin/>
                    </a>
                    <a href="https://github.com/aerecurax" target="_blank" rel="noreferrer">
                        <FaGithub/>
                    </a>
                    <a href="https://x.com/aerecurax" target="_blank" rel="noreferrer">
                        <FaXTwitter/>
                    </a>
                    <a href="https://soundcloud.com/doakev" target="_blank" rel="noreferrer">
                        <FaSoundcloud/>
                    </a>
                    <a href="https://www.instagram.com/athenpixels" target="_blank" rel="noreferrer">
                        <FaInstagram/>
                    </a>
                </div>
            </div>
        </Layout>
    );
}

export default Main;
